// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y-CJ","colBig":"styles_colBig___dCYy","colSmall":"styles_colSmall__1B7Rw"};